import { render, staticRenderFns } from "./tree-model.vue?vue&type=template&id=0085d47c&scoped=true&"
import script from "./tree-model.vue?vue&type=script&lang=ts&"
export * from "./tree-model.vue?vue&type=script&lang=ts&"
import style0 from "./tree-model.vue?vue&type=style&index=0&id=0085d47c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085d47c",
  null
  
)

export default component.exports